import Lightning from "@lightningjs/sdk/src/Lightning";
import { AppSetup } from "../lib/app-setup";
import { AppData } from "@lightningjs/sdk";

export default class VideoCCSection
  extends Lightning.Component<Lightning.Component.TemplateSpecLoose>
  implements Lightning.Component<Lightning.Component.TemplateSpecLoose>
{
    ccLoaded: boolean = false;
    consumer:any;
    subtitle!: HTMLElement
    subtitleArea!: HTMLElement
    static override _template(): Lightning.Component.Template<Lightning.Component.TemplateSpecLoose> {
        return {
            w: (w: any) => w,
            h: (h: any) => h,
            VideoCCSection: {
              y: (h)=>h-50,
              w: (w: any) => w,
              mountY:1,
              visible: false,
              flex: { direction: "row", justifyContent: "center" },
              CCText: {
                visible: false,
                text: {
                  text: "",
                  wordWrapWidth: (w: any) => w,
                  maxLines: 10,
                  textAlign: "center",
                  paddingLeft: 20,
                  paddingRight: 20,
                  highlight: true,
                  highlightColor: 0x88000000,
                  highlightPaddingLeft: 20,
                  highlightPaddingRight: 20,
                  fontSize: 32,
                },
              },
              alpha: 1,
            }
          };
    }

    addCaption = (cc_path: any,consumer:any,) => {
      const {ccOptions} = AppData as AppSetup
      this.subtitle = $('#subtitle');
      this.subtitleArea = $("#subtitle span");
      ccOptions.updateCSS()
      this.consumer = consumer;
      this.removeCaption();
      var track = document.createElement("track");
      track.kind = "captions";
      track.label = "English";
      track.srclang = "en";
      track.src = cc_path;
      track.addEventListener("load", () => {
        this.setCCListeners();
        this.controlSubtitleVisibility()
        consumer.disableCCButton(false);
        this.ccLoaded = true;
      });
      track.addEventListener("error", () => {
        //consumer.disableCCButton(true);
        this.ccLoaded = false;
      });
      const el = this.getVideoElement();
      if(el){
        // @ts-ignore
        el.appendChild(track);
        // @ts-ignore
        el.textTracks[0].mode = "hidden";
      }
    };

    controlSubtitleVisibility = () => {
      const { appState } = AppData as AppSetup;
      if (appState?.showSubtitle === true) {
        this.showSubtitle();
      } else {
        this.hideSubtitle();
      }
    };

    removeCCListeners = () => {
      let tracks;
      let el;
      try {
        el = this.getVideoElement();
        if(el){
          // @ts-ignore
          tracks = el.textTracks[0];
        }
      } catch (e) { }
      if (!tracks) return;
      let cues = tracks.cues;
      let ths = this;
      for (var i in cues) {
        var cue = cues[i];
        try {
          cue.onenter = null;
          cue.onexit = null;
        } catch (e) { }
      }
      if (el && el.childNodes && el.childNodes[0]) {
        el.removeChild(el.childNodes[0]);
      }
    };

    setCCListeners = () => {
      const el = this.getVideoElement();
      if(el){
      // @ts-ignore
      let tracks = el.textTracks[0];
      tracks.mode = "hidden"; // must occur before cues is retrieved
      let cues = tracks.cues;
      let ths = this;
      for (var i in cues) {
        var cue = cues[i];
        try {
          cue.onenter = function () {
            ths.cueEnter(this.text);
          };
          cue.onexit = this.cueExit;
        } catch (e) { }
      }}
    };

    cueEnter = (text: any) => {
      this.replaceCCText(text);
      this.showCCText();
    };
    cueExit = () => {
      this.hideCCText();
    };
    removeCaption = () => {
      this.hideCCText() // XFIN-677 - on before clearing hiding the cc element
      this.removeCCListeners();
      const el = this.getVideoElement();
      if(el){
        $(el).find("track").remove();
      }
    };

    replaceCCText = (_text: any) => {
      $(this.subtitleArea).html(_text);
      // let text = this.removeHtmlTags(_text);
      // this.patch({
      //   VideoCCSection: {
      //     CCText: {
      //       text: {
      //         text: text,
      //       },
      //     },
      //   },
      // });
    };

    removeHtmlTags = (str:any) => {
      if ((str===null) || (str==='')) {
        return '';
      } else {
        str = str.toString();
      }
      return str.replace( /(<([^>]+)>)/ig, '');
    }

    showCCText = () => {
      $(this.subtitleArea).show();      
    };

    hideCCText = () => {
      $(this.subtitleArea).hide();
    };

    showSubtitle = () => {
      $(this.subtitle).show();
    };

    hideSubtitle = () => {
      $(this.subtitle).hide();
    };
    get _ccLoaded(){
      return this.ccLoaded;
    }

    getVideoElement=()=>{
      let _videoEl = null;
      if(this.consumer && this.consumer.videoEl){
        return this.consumer.videoEl;
      }
      return _videoEl;
    }
}
